<template>
  <section class="cancelled-deliveries-config">
    <h4 class="cancelled-deliveries-config__title">Asignación de envíos cancelados</h4>
    <p class="cancelled-deliveries-config__hint">
      Al cancelar un envío se asignará automáticamente al conductor seleccionado (ej: DEPÓSITO).
    </p>

    <form class="cancelled-deliveries-config__form" @submit.stop.prevent="onSubmit">
      <AppField label="Conductor">
        <AppSelect
          v-model="form.driverId"
          :options="driverOptions"
          :disabled="loadingDrivers"
        />
      </AppField>

      <div class="cancelled-deliveries-config__actions">
        <AppButton
          variant="primary"
          type="submit"
          :disabled="loading || loadingDrivers"
        >
          Guardar
        </AppButton>
      </div>
    </form>
  </section>
</template>

<script>
import { mapActions } from 'vuex'
import AppField from '../UI/AppField'
import AppSelect from '../UI/AppSelect'
import AppButton from '../UI/AppButton'

export default {
  name: 'CancelledDeliveriesDriverConfig',
  components: {
    AppField,
    AppSelect,
    AppButton
  },
  data () {
    return {
      loading: false,
      loadingDrivers: false,
      drivers: [],
      form: {
        driverId: ''
      }
    }
  },
  computed: {
    driverOptions () {
      return [
        { value: '', text: 'Sin asignación automática' },
        ...this.drivers.map(driver => ({
          value: String(driver.id),
          text: `${driver.name} ${driver.lastName || ''} (${driver.codeDriver || '-'})`.trim()
        }))
      ]
    }
  },
  methods: {
    ...mapActions([
      'getDrivers',
      'getCancelledDeliveriesConfig',
      'updateCancelledDeliveriesConfig'
    ]),
    async fetchDrivers () {
      this.loadingDrivers = true
      try {
        const drivers = await this.getDrivers()
        this.drivers = Array.isArray(drivers) ? drivers : []
      } catch (error) {
        this.$toast.danger('Error al cargar los conductores')
      } finally {
        this.loadingDrivers = false
      }
    },
    async fetchConfig () {
      try {
        const response = await this.getCancelledDeliveriesConfig()
        const { driverId } = response.data
        this.form.driverId = driverId ? String(driverId) : ''
      } catch (error) {
        this.$toast.danger('Error al cargar la configuración')
      }
    },
    async onSubmit () {
      this.loading = true
      try {
        const driverId = this.form.driverId ? Number(this.form.driverId) : null
        await this.updateCancelledDeliveriesConfig({ data: { driverId } })
        this.$toast.success('Configuración guardada exitosamente')
      } catch (error) {
        this.$toast.danger(this.getErrorMessage(error))
      } finally {
        this.loading = false
      }
    },
    getErrorMessage (error) {
      if (error && error.response && error.response.data && error.response.data.message) {
        return error.response.data.message
      }
      if (error && error.message) {
        return error.message
      }
      return 'Ocurrió un error'
    }
  },
  mounted () {
    this.fetchDrivers()
    this.fetchConfig()
  }
}
</script>

<style scoped>
.cancelled-deliveries-config {
  display: grid;
  gap: 1rem;
}

.cancelled-deliveries-config__title {
  margin: 0;
}

.cancelled-deliveries-config__hint {
  margin: 0;
  color: #6b7280;
  font-size: 0.875rem;
}

.cancelled-deliveries-config__form {
  display: grid;
  gap: 0.5rem;
}

.cancelled-deliveries-config__actions {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
